
































import Vue from 'vue';

import { REQUEST_TYPE } from '@/config';
import Tab from '@/components/ui/tab/tab.vue';

import { TABS } from '../../config';
import CurrentTrack from './current-track.vue';
import Statistics from './statistics.vue';
import Process from '../tabs/process.vue';
import Help from '../tabs/help.vue';
import Weights from '../tabs/weights.vue';

export default Vue.extend({
  name: 'Player',

  props: {
    track: {
      type: Object,
      default: null,
    },
  },

  components: {
    CurrentTrack,
    Process,
    Statistics,
    Tab,
    Help,
    Weights,
  },

  data: () => ({
    tabs: TABS,
    tab: REQUEST_TYPE.NONE,
    opened: 0,
    requestTypes: REQUEST_TYPE,
  }),

  methods: {
    openTab(id: string) {
      if (id === this.tab) {
        this.tab = REQUEST_TYPE.NONE;
      } else if (Date.now() - this.opened > 500) {
        this.tab = id;
        this.opened = Date.now();
      }
    },
  },
});
